import { render, staticRenderFns } from "./EditRoleDialog.vue?vue&type=template&id=887dc60c&scoped=true"
import script from "./EditRoleDialog.vue?vue&type=script&lang=js"
export * from "./EditRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./EditRoleDialog.vue?vue&type=style&index=0&id=887dc60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887dc60c",
  null
  
)

export default component.exports